(function () {
  /**
   * @ngdoc service/provider
   * @name jilFulfillmentEvents
   * @description defines service to manage the jil fulfillment events resource
   */
  angular.module('app.core.api.jil').provider('jilUserAuthorization', provider);

  let url;

  /* @ngInject */
  function provider() {
    this.configure = configure;
    this.$get = $get;

    ////////////

    function configure(config) {
      url = `${config.url}/v2/user/authorization`;
    }

    /* @ngInject */
    function $get($resource) {
      const service = {
        userAuthorization: getUserAuthorizationResource(),
      };

      return service;

      ///////////

      function getUserAuthorizationResource() {
        return $resource(url);
      }
    }
  }
})();
